import React, { useState, useEffect } from 'react';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
            <circle cx="25" cy="25" r="23" stroke="currentColor" strokeWidth="2"/>
            <path d="M15 25 L22 32 L35 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Consultant Portfolio</span>
        </div>
        <nav className="nav">
          <a href="#home" className="nav-link"><span className="nav-number"></span>Home</a>
          <a href="#about" className="nav-link"><span className="nav-number"></span>Professional Overview</a>
          <a href="#skills" className="nav-link"><span className="nav-number"></span>Skills</a>
          <a href="#projects" className="nav-link"><span className="nav-number"></span>Projects</a>
          <a href="#contact" className="nav-link"><span className="nav-number"></span>Contact</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;

